import { Injectable } from "@angular/core";
import { Http, Headers } from '@angular/http';
import { Constants } from '../util/Constants';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Util } from '../util/Util';

@Injectable()
export class RestService {

	constructor(private http:Http) {

  }

  public checkVersion() {
    return this.http.get(Util.getVersionUrl()).map(response => response.json()).toPromise();
  }

	public login(mobile: string, password: string) {
		let param = {"mobileNumber" : mobile, "password" : password};
		let reqBody = this.createRestReqObj(Constants.WS_CODE_GET_USER_REQUEST, param);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');

    return this.http.post(Util.getIadsBaseUrl() + "/rest/service/logon", reqBody, {headers: headers})
    .map(
      res => {
        if(res.json().result) {
          return res.json();
        } else {
          var err = {};
          err["raw"] = res.json();
          err["message"] = "Login Error";
          err["code"] = res.json().code;
          throw err;
        }
      }
    )
    .toPromise();
	}

  public regusterGuestAccount() {
		let param = {"nickname" : Constants.GUEST_ACCOUNT_USERNAME, "password" : Constants.GUEST_ACCOUNT_PASSWORD};
		let reqBody = this.createRestReqObj(Constants.WS_CODE_REG_USER_REQUEST, param);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');

    return this.http.post(Util.getIadsBaseUrl() + "/rest/service/registration", reqBody, {headers: headers})
    .map(
      res => {
        if(res.json().result) {
          return res.json();
        } else {
          var err = {};
          err["raw"] = res.json();
          err["message"] = "Register Error";
          err["code"] = res.json().code;
          throw err;
        }
      }
    )
    .toPromise();
  }

  public reqSMSCode(phoneNum, device, langName) {
		let param = {"phone" : phoneNum, "device" : device, "lang" : langName};
		let reqBody = this.createRestReqObj(Constants.WS_CODE_GET_ACTIVATION_CODE_REQUEST, param);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');

    return this.http.post(Util.getIadsBaseUrl() + "/rest/service/activation/request", reqBody, {headers: headers})
    .map(
      res => {
        return res.json();
      }
    )
    .toPromise();
  }

  public verifySMSCode(phoneNum, verifySMSCode) {
    let param = {"phone" : phoneNum, "code" : verifySMSCode};
		let reqBody = this.createRestReqObj(Constants.WS_CODE_VERIFY_ACTIVATION_CODE_REQUEST, param);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');

    return this.http.post(Util.getIadsBaseUrl() + "/rest/service/activation/verify", reqBody, {headers: headers})
    .map(
      res => {
        return res.json();
      }
    )
    .toPromise();
  }

  public checkNameAvailable(nickname) {
    let param = {"nickname" : nickname};
		let reqBody = this.createRestReqObj(Constants.WS_CODE_GET_USER_REQUEST, param);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');

    return this.http.post(Util.getIadsBaseUrl() + "/rest/service/checkNameAvailable", reqBody, {headers: headers})
    .map(
      res => {
        return res.json();
      }
    )
    .toPromise();
  }

  public resetPassword(mobile, langName) {
    let param = {"mobileNumber" : mobile, "lang" : langName};
		let reqBody = this.createRestReqObj(Constants.WS_CODE_RESET_USER_PASSWORD_REQUEST, param);
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');

    return this.http.post(Util.getIadsBaseUrl() + "/rest/service/resetPwd", reqBody, {headers: headers})
    .map(
      res => {
        return res.json();
      }
    )
    .toPromise();
  }

	private createRestReqObj (command: number, param: Object) {
		let commandKey = Constants.WS_CODES_KEY_MAP[command];
		let reqRootObj = {};
		let reqChildObj = {};
		reqChildObj[commandKey] = param;
		reqChildObj["command"] = command;
		reqChildObj["seq"] = 1;
		reqRootObj["BackendEvent"] = reqChildObj;
		return reqRootObj;
	};
}



// WEBPACK FOOTER //
// ./src/services/restService.ts